import { scopedT } from '../../utils/functions/scopedT';
import { ErrorPage } from '../ErrorPage';

const t = scopedT();

export const NotFound = () => {
  return (
    <ErrorPage
      title={t('notFound.title')}
      message={t('notFound.description')}
    />
  );
};
